import { observable, runInAction, configure, action } from "mobx";
import { ApiTokenApi, TenantApi } from "apis";
import ApiStore from "./ApiStore";
import BaseStore from "./BaseStore";

configure({ enforceActions: "observed" });

class ApiTokenStore extends BaseStore {
    @observable apiTokens = []; // API-Token一覧表示

    constructor(props) {
        super(props);
        this.api = new ApiTokenApi();
        this.tenantApi = new TenantApi();
    }

    @action
    getTenantTokens = async () => {
        this.clean();
        // テナントAPI-Token一覧取得
        let response = await ApiStore.call(this.api, this.api.getTenantTokens);
        if (response) {
            runInAction(() => {
                this.apiTokens = response;
            })
        }
    }

    @action
    generateTenantToken = async () => {
        // テナントAPI-Token生成
        let response = await ApiStore.call(this.api, this.api.generateTenantToken);
        if (response) {
            runInAction(() => {
                // 生成したAPI-Tokenを挿入
                this.apiTokens.splice(0, 0, response);
                this.apiTokens = JSON.parse(JSON.stringify(this.apiTokens));
            })
        }
    }

    @action
    updateTenantToken = async (payload) => {
        // テナントAPI-Token生成
        let response = await ApiStore.call(this.api, this.api.updateTenantToken, payload);
        if (response) {
            runInAction(() => {
                // 更新データを差し換え
                this.apiTokens = this.apiTokens.map(e => {
                    if (e.id == response.id) {
                        e.comment = response.comment;
                    }
                    return e;
                });
            })
        }
    }

    @action
    deleteTenantToken = async (id) => {
        // テナントAPI-Token生成
        let response = await ApiStore.call(this.api, this.api.deleteTenantToken, id);
        if (response) {
            runInAction(() => {
                // データを削除
                this.apiTokens = this.apiTokens.filter(e => e.id != response.id);
            })
        }
    }

    @action
    getTeamTokens = async (teamsId, tenantId = null) => {
        this.clean();
        // チームAPI-Token一覧取得
        if (tenantId !== null) {
            let payload = { teamsId, tenantId };
            let response = await ApiStore.call(this.tenantApi, this.tenantApi.getTenantTeamTokens, payload);
            if (response) {
                runInAction(() => {
                    this.apiTokens = response;
                })
            }
        } else {
            let response = await ApiStore.call(this.api, this.api.getTeamTokens, teamsId);
            if (response) {
                runInAction(() => {
                    this.apiTokens = response;
                })
            }
        }
    }

    @action
    generateTeamToken = async (teamsId, tenantId = null) => {
        // チームAPI-Token生成
        if (tenantId !== null) {
            let payload = { teamsId, tenantId };
            let response = await ApiStore.call(this.tenantApi, this.tenantApi.generateTenantTeamToken, payload);
            if (response) {
                runInAction(() => {
                    // 生成したAPI-Tokenを挿入
                    this.apiTokens.splice(0, 0, response);
                    this.apiTokens = JSON.parse(JSON.stringify(this.apiTokens));
                })
            }
        } else {
            let response = await ApiStore.call(this.api, this.api.generateTeamToken, teamsId);
            if (response) {
                runInAction(() => {
                    // 生成したAPI-Tokenを挿入
                    this.apiTokens.splice(0, 0, response);
                    this.apiTokens = JSON.parse(JSON.stringify(this.apiTokens));
                })
            }
        }
    }

    @action
    updateTeamToken = async (payload, tenantId = null) => {
        // チームAPI-Token生成
        if (tenantId !== null) {
            payload['tenantId'] = tenantId;
            let response = await ApiStore.call(this.tenantApi, this.tenantApi.updateTenantTeamToken, payload);
            if (response) {
                runInAction(() => {
                    // 更新データを差し換え
                    this.apiTokens = this.apiTokens.map(e => {
                        if (e.id == response.id) {
                            e.comment = response.comment;
                        }
                        return e;
                    });
                })
            }
        } else {
            let response = await ApiStore.call(this.api, this.api.updateTeamToken, payload);
            if (response) {
                runInAction(() => {
                    // 更新データを差し換え
                    this.apiTokens = this.apiTokens.map(e => {
                        if (e.id == response.id) {
                            e.comment = response.comment;
                        }
                        return e;
                    });
                })
            }
        }
    }

    @action
    deleteTeamToken = async (id, tenantId = null) => {
        // チームAPI-Token生成
        if (tenantId !== null) {
            let payload = { id, tenantId };
            let response = await ApiStore.call(this.tenantApi, this.tenantApi.deleteTenantTeamToken, payload);
            if (response) {
                runInAction(() => {
                    // データを削除
                    this.apiTokens = this.apiTokens.filter(e => e.id != response.id);
                })
            }
        } else {
            let response = await ApiStore.call(this.api, this.api.deleteTeamToken, id);
            if (response) {
                runInAction(() => {
                    // データを削除
                    this.apiTokens = this.apiTokens.filter(e => e.id != response.id);
                })
            }
        }
    }

    @action
    clean() {
        super.clean();
        this.apiTokens = [];
    }
}

export default ApiTokenStore;